import { memo, forwardRef, type Ref } from 'react';
import type { InputHTMLAttributes } from 'react';
import { _js } from '@ifixit/localize';

type SearchInputProps = {
   className?: string;
   containerProps?: Record<string, any>;
} & InputHTMLAttributes<HTMLInputElement>;

const SearchInputComponent = (
   { className, containerProps, ...props }: SearchInputProps,
   ref: Ref<HTMLInputElement>
) => {
   const searchlabel = _js('Search');

   return (
      <div className={`my-4 ${className ? className : ''}`} {...containerProps}>
         <input
            className="border rounded-lg bg-white py-2 px-3 h-[48px] text-[16px] w-full"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            type="search"
            aria-label={searchlabel}
            placeholder={searchlabel}
            ref={ref}
            {...props}
         />
      </div>
   );
};

export const SearchInput = memo(
   forwardRef<HTMLInputElement, SearchInputProps>(SearchInputComponent)
);
